import type { UserRole } from "../context/auth-context";

/**
 * Returns the default post-auth route for a given role.
 */
export function getDefaultRouteForRole(role: UserRole): string {
  switch (role) {
    case "admin":
      return "/admin";
    case "user":
      return "/dashboard";
    default:
      return "/";
  }
}
